export function getAtPath(obj, path) {
    return path.reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
}

export function setAtPath(obj, path, value) {
    if (!path || path.length === 0) return value;

    const rootClone = Array.isArray(obj) ? obj.slice() : { ...(obj || {}) };

    let cur = rootClone;
    for (let i = 0; i < path.length - 1; i++) {
        const key = path[i];
        const nextKey = path[i + 1];

        const existing = cur[key];
        let next;
        if (existing == null) {
            next = typeof nextKey === "number" ? [] : {};
        } else {
            next = Array.isArray(existing) ? existing.slice() : { ...existing };
        }

        cur[key] = next;
        cur = next;
    }

    cur[path[path.length - 1]] = value;
    return rootClone;
}

export function updateAtPath(obj, path, updater) {
    const prev = getAtPath(obj, path);
    const next = updater(prev);
    return setAtPath(obj, path, next);
}
